import React, {useEffect, useState} from 'react';
import taxActions from '../../actions/tax.actions';
import {Maintenance, TaxRecordInterviewIframe} from './components';
import {useDispatch, useSelector} from 'react-redux';
import {Icon, svgs} from 'epic-diesel-common';
import {getLocale} from 'epic-common/src/locale';
import {LoadIndicator} from '../../components';
import {withPageLayout, WithPageLayoutProps} from '../../hocs';
import {selectAffiliateLoading} from '../../selectors';
import Settings from './Settings';

//@ts-ignore
import styles from './Settings.pcss';

export type SettingsViewProps = WithPageLayoutProps;

const SettingsView: React.FC<SettingsViewProps> = props => {
    const dispatch = useDispatch();
    const isAffiliateLoading = useSelector(selectAffiliateLoading);
    const [iFrameLoaded, setIFrameLoaded] = useState(false);
    const {configState, taxState, messages} = props || {};

    useEffect(() => {
        dispatch(taxActions.resetInterview());
        dispatch(taxActions.getTaxRecord());

        return () => {
            dispatch(taxActions.resetInterview());
        };
    }, []);

    const isLoading = taxState.loading || isAffiliateLoading;

    return (
        <LoadIndicator isLoading={isLoading} messages={messages}>
            {configState.enableMaintenance ? (
                <Maintenance />
            ) : taxState.taxInterviewUrl ? (
                <div className={styles.iframeWrapper}>
                    {!iFrameLoaded && (
                        <div className={styles.loader}>
                            <Icon className={styles.icon} icon={svgs.LOADING} fontSize="large" />
                        </div>
                    )}

                    <TaxRecordInterviewIframe
                        src={taxState.taxInterviewUrl}
                        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
                        title="Tax Identity Interview"
                        rtl={getLocale() === 'ar'}
                        onLoad={() => setIFrameLoaded(true)}
                    />
                </div>
            ) : (
                <Settings {...props} />
            )}
        </LoadIndicator>
    );
};

export default withPageLayout(SettingsView, {skipEditSettingsCheck: false});
